import { translateKey } from '../../../../../translate';
import { Icon } from '../../../../elements/common';

export function ExtendPermission(props: { onClick: () => void; show: boolean }) {
    return (
        <div
            className="details__link"
            onClick={props.onClick}
        >
            <Icon icon={props.show ? 'caret-up' : 'caret'} />
            <span>{!props.show ? translateKey('request.showDetails') : translateKey('request.hideDetails')}</span>
        </div>
    );
}
